import { CRITICAL_EXPIRY_DAYS, WARNING_EXPIRY_DAYS } from '@/const/artifact-expiry'

import { MILLISECONDS_IN_A_DAY, formatDate } from '@/lib/date/date'

import { Badge, BadgeProps } from '@/components/lemmala-design-system/badge/badge'
import { Tooltip } from '@/components/lemmala-design-system/tooltip/tooltip'

type ArtifactExpirationDateProps = {
  expirationDate: Date
  variant?: BadgeProps['variant']
}

export const ArtifactExpirationDate = ({
  expirationDate,
  variant,
}: ArtifactExpirationDateProps) => {
  const currentDate = new Date()

  if (expirationDate > new Date(currentDate.setDate(currentDate.getDate() + WARNING_EXPIRY_DAYS))) {
    return null
  }

  const isExpired = expirationDate < new Date()
  const daysToExpire = Math.floor(
    (expirationDate.getTime() - new Date().getTime()) / MILLISECONDS_IN_A_DAY,
  )
  const label = isExpired ? 'Expired' : 'Expires'
  const labelText = `${label} ${formatDate(expirationDate, 'dateWithoutYear')}`

  return (
    <Tooltip
      trigger={
        <Badge
          variant={
            variant ||
            (isExpired ? 'danger' : daysToExpire < CRITICAL_EXPIRY_DAYS ? 'warning' : 'attention')
          }
          badgeStyle={'subtle'}
        >
          {labelText}
        </Badge>
      }
    >
      <div className='px-4 py-1 text-center'>
        <span>This artifact {label} on</span>
        <br />
        <span>
          {formatDate(expirationDate)} {!isExpired && `(${daysToExpire} days)`}
        </span>
      </div>
    </Tooltip>
  )
}
